import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { Article } from './pages/Article';
export const ARTICLE_PATH = '/news/don-callaway-ferrari-case';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbt2ovkq6938">
      <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-1" data-mp="3fb9it9bilamk">
        <SiteHeader data-id="element-2" data-mp="2rlp08rj9wfdt" />
        <div className="flex-1" data-id="element-3" data-mp="2rl6t2zv2ogr4">
          <Routes data-id="element-4" data-mp="2mlu68f47b9oj">
            <Route path={ARTICLE_PATH} element={<Article data-id="element-6" data-mp="2mndqshww46w4" />} data-id="element-5" data-mp="2mmlt91jqfz37" />
            <Route path="*" element={<Navigate to={ARTICLE_PATH} replace data-id="element-8" data-mp="31agq8u4rwpm3" />} data-id="element-7" data-mp="2mjzo18kbdvo5" />
          </Routes>
        </div>
        <SiteFooter data-id="element-9" data-mp="2wk0bn6p7uxy5" />
      </div>
    </BrowserRouter>;
}